var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 3H16.5V0.5625C16.5 0.251859 16.2481 0 15.9375 0H14.0625C13.7519 0 13.5 0.251859 13.5 0.5625V3H7.5V0.5625C7.5 0.251859 7.24814 0 6.9375 0H5.0625C4.75186 0 4.5 0.251859 4.5 0.5625V3H2.25C1.00734 3 0 4.00734 0 5.25V21.75C0 22.9927 1.00734 24 2.25 24H18.75C19.9927 24 21 22.9927 21 21.75V5.25C21 4.00734 19.9927 3 18.75 3ZM18.4688 21.75H2.53125C2.37592 21.75 2.25 21.6241 2.25 21.4688V7.5H18.75V21.4688C18.75 21.6241 18.6241 21.75 18.4688 21.75ZM9.32036 18.9565L15.9911 12.3392C16.2116 12.1205 16.2131 11.7643 15.9943 11.5437L14.9379 10.4788C14.7191 10.2583 14.363 10.2569 14.1424 10.4757L8.93593 15.6404L6.86856 13.5563C6.64979 13.3357 6.29364 13.3343 6.07309 13.553L5.00814 14.6094C4.78759 14.8282 4.78618 15.1844 5.00495 15.4049L8.52484 18.9533C8.74365 19.1739 9.09981 19.1753 9.32036 18.9565Z",
    fill: "#0A68FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default ForwardRef;